import React, { useState, useEffect } from 'react';
import './BackToTop.css';

const BackToTop = () => {
    const [visible, setVisible] = useState(false);

    // Função para monitorar o scroll
    const toggleVisible = () => {
        const scrolled = document.documentElement.scrollTop;
        if (scrolled > 300) {
            setVisible(true);
        } else if (scrolled <= 300) {
            setVisible(false);
        }
    };

    // Função para subir ao topo suavemente
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    useEffect(() => {
        window.addEventListener('scroll', toggleVisible);
        return () => window.removeEventListener('scroll', toggleVisible);
    }, []);

    return (
        <button
            className={`back-to-top ${visible ? 'show' : ''}`}
            onClick={scrollToTop}
            aria-label="Voltar ao topo"
        >
            ↑
        </button>
    );
};

export default BackToTop;